<!-- Bootstrap Login Form -->
<div class="container min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row w-100 justify-content-center">
        <div class="col-md-4">
            <div class="card">
                <div class="card-body">
                    <h3 class="card-title text-center mb-4"><strong>Assets Monitor Tool</strong></h3>
                    <form (ngSubmit)="login($event)">
                        <div class="mb-3">
                            <label for="email" class="form-label">Email address</label>
                            <input type="email" class="form-control" id="email" placeholder="Enter email" required [(ngModel)]="email" name="email">
                        </div>
                        <div class="mb-3">
                            <label for="password" class="form-label">Password</label>
                            <input type="password" class="form-control" id="password" placeholder="Password" required [(ngModel)]="password" name="password">
                        </div>
                        <button type="submit" class="btn btn-primary w-100 text-light" [disabled]="loading">
                            {{ loading ? 'Logging in...' : 'Login' }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>